
<!-- <link rel="stylesheet" href="style.css">
<link rel="stylesheet" href=" https://cdn.rawgit.com/sachinchoolur/lightgallery.js/master/dist/css/lightgallery.css">
<script src="https://cdn.rawgit.com/sachinchoolur/lightgallery.js/master/dist/js/lightgallery.js"></script>
<script src="https://cdn.rawgit.com/sachinchoolur/lg-pager.js/master/dist/lg-pager.js"></script>
<script src="https://cdn.rawgit.com/sachinchoolur/lg-autoplay.js/master/dist/lg-autoplay.js"></script>
<script src="https://cdn.rawgit.com/sachinchoolur/lg-share.js/master/dist/lg-share.js"></script>
<script src="https://cdn.rawgit.com/sachinchoolur/lg-fullscreen.js/master/dist/lg-fullscreen.js"></script>
<script src="https://cdn.rawgit.com/sachinchoolur/lg-zoom.js/master/dist/lg-zoom.js"></script>
<script src="https://cdn.rawgit.com/sachinchoolur/lg-hash.js/master/dist/lg-hash.js"></script>
<script src="https://cdn.jsdelivr.net/picturefill/2.3.1/picturefill.min.js"></script> -->



<!------------------Small Devices Design code start here------------------------------->

<div class="container-fluid">
    <div class="post-title global_section_header mx-5 text-center" role="heading" >How Technology can Amplify business efficiency for manufacturers in Industry 4.0 (INFOGRAPHICS)</div>
    <div class="post-meta mt-20" style="display: flex; justify-content: center;">
      <div class="post-date">
        <span class="meta-icon"><i class="fa-regular fa-calendar-days"></i></span>
         
            November, 2023
      </div>
      <div class="post-view view-item1">

             <span class="meta-icon"> <i class=" fa-solid fa-eye"></i></span>

          560 views
      </div>
      <div class="post-read view-item2">       
         <span class="meta-icon"> <i class="fa fa-book"></i></span>

          3 min Read             
      </div>                        
    </div>

       

  <div class="container-fluid">
      <div class="row">
        
        <div class="col-md-8">        
            <img src="../../../assets/images/Infographic-blog-images/Infographic-img.png" class="img-responsive;" style="width: 98%" alt="Infographic-img" />
        </div>

        <div class="col-lg-4">
          <div class="tab m-3">
            <h6 class="pt-3" style="color: #A348E8; font-size:18px"> Recent Posts </h6>
            
            <hr>
            <li class="tick" style="list-style-type: none; "><a href="/postpandamic">The new wave of Digital Marketing in the Post-Pandemic world</a></li>

            <hr>
            <li class="tick" style="list-style-type: none; " ><a href="/migrate-cloud">Why is cloud migration critical in the covid-19 scenario</a></li>

            <hr>
            <li class="tick" style="list-style-type: none; " ><a href="/h1b-visa">What is H1-B Visa</a></li>
      
            <hr>
            <li class="tick" style="list-style-type: none; " ><a href="/digital-partner">How to choose your digital partner?</a></li>

            <hr>
            <li class="tick" style="list-style-type: none; " ><a href="/cloud-cost-optimization">Cloud optimization strategies that drove 50% cost savings</a></li>
          </div>
        </div> 
      </div>
</div>





